















































































































































import ViewTemplateForm from './ViewTemplateForm'
export default ViewTemplateForm
